"use strict";

define('rs/models/group',['rs/models/abstract', 'rs/models/person'], function (RSAbstractModel, RSPersonModel) {
  var GroupModel = RSAbstractModel.extend({
    properties: ['active', 'activityDate', 'description', 'id', 'members', 'name', 'tag', 'updateUser', 'version'],
    serverProperties: ['active', 'description', 'id', 'name', 'tag'],
    requestLoadById: function requestLoadById() {
      return this.constructor.requestLoadById(this.getId());
    },
    requestUpdate: function requestUpdate(newData) {
      this.applyProperties(newData);
      return this.constructor.requestUpdate(this);
    },
    requestDelete: function requestDelete() {
      return this.constructor.requestDelete(this.getId());
    },
    requestMembers: function requestMembers() {
      var that = this;
      return this.constructor.requestMembersByGroupId(this.getId()).then(function (members) {
        that.setMembers(members);
        return members;
      });
    },
    requestAddMember: function requestAddMember(personId) {
      return this.constructor.requestAddMember(this.getId(), personId);
    },
    requestRemoveMember: function requestRemoveMember(personId) {
      return this.constructor.requestRemoveMember(this.getId(), personId);
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#get#group(?*query)': function getGroupQuery(data) {
        return this.models(data);
      },
      '#post#group': function postGroup(data) {
        return this.model(data);
      },
      '#get#group/:id/member': function getGroup_Id_member(data) {
        return RSPersonModel.models(data);
      },
      '#put#group/:id/member/:id': function putGroup_Id_member_Id(data) {
        return RSPersonModel.model(data);
      }
    },
    requestLoadById: function requestLoadById(groupId) {
      return this.get('group/' + groupId);
    },
    requestLoadAll: function requestLoadAll(options) {
      var params = {};
      if (options && options.tag) {
        var tags = this.tags;
        params.tag = tags[options.tag] ? tags[options.tag] : options.tag;
      }
      if (options && options.active) {
        params.active = options.active;
      }
      return this.get('group', params);
    },
    requestCreate: function requestCreate(groupData) {
      var tags = this.tags;
      groupData.tag = tags[groupData.tag] ? tags[groupData.tag] : groupData.tag;
      return this.post('group', groupData, {
        jsonBody: true
      });
    },
    requestUpdate: function requestUpdate(groupData) {
      return this.put('group/' + groupData.getId(), groupData);
    },
    requestDelete: function requestDelete(groupId) {
      return this.del('group/' + groupId);
    },
    requestMembersByGroupId: function requestMembersByGroupId(groupId) {
      return this.get('group/' + groupId + '/member');
    },
    requestAddMember: function requestAddMember(groupId, personId) {
      return this.put('group/' + groupId + '/member/' + personId);
    },
    requestRemoveMember: function requestRemoveMember(groupId, personId) {
      return this.del('group/' + groupId + '/member/' + personId);
    },
    requestGroupsByCurrentUser: function requestGroupsByCurrentUser() {
      return this.get('group/user/list');
    },
    tags: {
      IRB_BOARD: 'IRB_BOARD',
      IRB_ANALYST: 'IRB_ANALYST',
      IRB_ORGAPPROVER: 'IRB_ORGAPPROVER'
    }
  });
  return GroupModel;
});

